import { useTranslation } from 'react-i18next';
import { captureException } from '@sentry/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteTeamComment } from '@/api/v4/team-comments.api';
import { notify } from '@/ui/snackbar/notify';
import { QueryKey } from '@/config/query-client';

type DeleteTeamCommentMutationParams = {
  teamId: string;
  commentId: string;
};

export const useDeleteTeamComment = () => {
  const { t } = useTranslation('default');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      teamId,
      commentId,
    }: DeleteTeamCommentMutationParams) => {
      return deleteTeamComment(teamId, commentId);
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.TeamComments, variables.teamId],
      });
    },
    onError: (error: Error) => {
      notify({
        message: t`unknownError`,
      });
      captureException(error);
    },
  });
};
